export const Van = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="23" cy="24" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="9" cy="24" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M20 24H12" stroke="currentColor" stroke-width="2"/>
<path d="M26 24H29V16L22 7H3V24H6" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M19 7V16H29" stroke="currentColor" stroke-width="2"/>
</svg>`;
